<template>
  <div class="EmailSear" style="margin-left:10px;">
    <div class="EmailField" style="border-radius: 10px 10px 10px 10px;
    box-shadow: 1px 3px 3px 3px lightgray; width:450px; height: 100px; margin-left:40px;">
      <div class="EmailInfo">
        <p style="padding-top:10px; margin-left:30px;">사용자 정보 검색</p>
        </div>
        <div class="emailContent" style="display:flex; margin-left: 30px;">
          <div>
            <vs-input
              v-validate="'required|email'"
              data-vv-validate-on="blur"
              name="email"
              type="email"
              icon-pack="feather"
              icon-no-border
              icon="icon icon-mail"
              label-placeholder="Email"
              style="width:200px; height:40px"
              @keyup.enter="searchingMail"
              v-model="emailValue"/>
          </div>
            <vs-button v-bind:disabled="emailValue == ''" @click="searchingMail()" style="margin-top:16px; margin-left:22px; height:40px">사용자 정보 검색
            </vs-button>
        </div>
    </div>
  <div class="emailText" v-show="emailInfoCard" style="width:500px; height:300px; margin-left:40px;">
    <div class="emailInput" style="display:flex; justify-content:space-around; border-radius: 10px 10px 10px 10px;
    box-shadow: 1px 3px 3px 3px lightgray; width:720px; height: 230px; margin-top:30px;">
      <div class="emailImg" style="display:right; margin-left:10px;">
        <img :src="sear_photo_url" style="width:170px; height:170px; margin-top:35px">
      </div>
      <div style="display:left">
        <div style="display:flex; margin-top:10px;">
        <vs-input disabled class="mb-base" label="이름" placeholder="user-name" style="width:230px; margin-right:10px;" v-model="emailList.name" />
        <vs-input disabled class="mb-base" label="이메일" placeholder="user-email" style="width:230px;" v-model="emailList.email" />
      </div>
      <div style="display:flex; margin-top:-15px;">
          <vs-input disabled class="mb-base" label="계정 생성 날짜" placeholder="create-account" style="width:230px; margin-top:1px; margin-right:10px;" v-model="emailList.create_time" />
          <vs-input disabled class="mb-base" label="최근 로그인 날짜" placeholder="last-login_time" style="width:230px; margin-top:1px" v-model="emailList.login_time" />
      </div>
      <div style="display:flex; margin-top:-15px;">
          <vs-input class="mb-base" label="레벨" placeholder="user-level" style="width:100px; margin-top:1px; margin-right:10px;" v-model="levelV" />
          <vs-input class="mb-base" label="별 포인트" placeholder="starV" style="width:110px; margin-top:1px; margin-right:10px;" v-model="starV" />
          <vs-button @click="saveInfo()" style="height:40px; margin-top:20px; margin-left:160px;" type="border" icon-pack="feather" size="small" icon="icon-save">저장
          </vs-button>
      </div>
     </div>
    </div>
   </div>
  </div>
</template>

<script>
export default {
  data() {
    return {
      emailValue: '',
      emailInfoCard: false,
      sear_photo_url: '',
      levelV: '',
      starV: '',
    }
  },
  watch: {
    emailList(){
      this.sear_photo_url = require("../../../assets/images/portrait/small/"+this.emailList.photo_url)
    }
  },
  computed: {
    emailList(){
      return this.$store.state.searchUser.emailList
    }
  },
  methods: {
   searchingMail() {
     this.$store.dispatch('searchUser/searchMail', this.emailValue)
      .then(()=>{
       this.levelV = this.emailList.level
       this.starV = this.emailList.star_point
       this.emailInfoCard = true
       })
       .catch(() => {
         this.$vs.notify({
           color: 'orange',
           title: '실패',
           text: '이메일 확인 후 다시 검색해주세요 :('
         })
       })
    },
    saveInfo() {
      if(this.emailList.star_point != this.starV | this.emailList.level != this.levelV){
        this.$store.dispatch('searchUser/updateUserinfo', {'id': this.emailList.id, 'star_point':this.starV, 'level': this.levelV})
          .then(()=>{
            this.$store.dispatch('searchUser/searchMail', this.emailValue)
            this.$vs.notify({
              color: 'success',
              title: '완료',
              text: '변경사항이 저장되었습니다 :)'
            })
          }).catch(() => {
            this.$vs.notify({
              color: 'danger',
              title: '실패',
              text: '관리자에게 문의 해주세요 :('
            })
          })
        }
      else {
        this.$vs.notify({
          color: 'gray',
          title: '유지',
          text: '변동 사항이 없어요 :D'
        })
      }
    }
  }
}
</script>
